import React from "react"
import Room from "../components/organisms/proposal/Room";

const Proposal = () => {
  return (
    <Room/>
  )
}

export default Proposal;